import React, { Component } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { ProgramasList } from './ProgramasList';
import { Tabs, Tab } from 'react-bootstrap';
//import { URL_API } from './conf/init';

import BlockUi from 'react-block-ui';
import { Loader } from 'react-loaders';
import 'react-block-ui/style.css';
import 'loaders.css/loaders.min.css';


export class Subsistemas extends Component {
    constructor(props) {
        super(props);
        this.state = {
            origen: props.match.params.origen,
            listaSubsistemas: [],
            idSubsistema: 0,
            idPrograma: 0,
            nombreSubsistema: '',
            listaProgramas: [],
            activeTab: props.activeTab || 1,
            activeKey: '0'
        };

        this.subsistemaClicked = this.subsistemaClicked.bind(this);
        this.limpiarConsulta = this.limpiarConsulta.bind(this);
    }

    async componentDidMount() {
        try {
            this.setState({ blocking: true, loaderType: 'ball-triangle-path' });
            console.log(process.env.REACT_APP_URL_API);
            var baseUrl = `${process.env.REACT_APP_URL_API}/api/Subsistema/Origen/${this.state.origen}`;
            const response = await axios.get(baseUrl);
            this.setState({ listaSubsistemas: response.data, idSubsistema: response.data[0].idSubsistema, nombreSubsistema : response.data[0].nombre });
            this.subsistemaClicked(this.state.idSubsistema);
            this.setState({ blocking: false });

        } catch (err) {
            this.setState({ blocking: false });
            alert("Ocurrió un error al obtener los subsistemas");
            return null;
        }
    }


    async subsistemaClicked(selectedTab) {

        try {
            var baseUrl = `${process.env.REACT_APP_URL_API}/api/Programa/Subsistema/${selectedTab}/origen/${this.state.origen}`;
            const response = await axios.get(baseUrl);
            this.setState({ listaProgramas: response.data, activeTab: selectedTab, activeKey: '0', nombreSubsistema : this.state.listaSubsistemas[selectedTab-1].nombre });            
        } catch (err) {
            console.log(err);
            alert("Ocurrió un error al obtener los programas");
            return null;
        }
    }

    limpiarConsulta(activeKey) {
        this.setState({ activeKey });
    }

    displayName = Subsistemas.name;

    render() {
        return (
            <div className='container' id='mainContainer2'>
                <div>
                    <h2>Acervo de Información de Interés Nacional</h2>
                    <p className='Encabezado2'>{this.state.origen === "2" ? 'IIN a partir de la entrada en vigor de la LSNIEG' : 'IIN antes de la entrada en vigor de la LSNIEG'}</p>
                    <div style={{ textAlign: 'right' }}>
                        <Link to="/">Regresar al inicio</Link>
                    </div>
                </div>
                <BlockUi tag="div" blocking={this.state.blocking} loader={<Loader active type={this.state.loaderType} color="#02a17c" message="Cargando" />}>

                    <div>
                        <Tabs activeKey={this.state.activeTab} onSelect={this.subsistemaClicked} id="ds" animation={false}>                        
                            {this.state.listaSubsistemas.map(res =>
                                <Tab key={res.idSubsistema} eventKey={res.idSubsistema} title={res.siglas} >
                                    <ProgramasList idSubsistema={this.state.idSubsistema} origen={this.state.origen} listaProgramas={this.state.listaProgramas} activeKey={this.state.activeKey} limpiarConsulta={this.limpiarConsulta} />
                                </Tab>
                            )}
                        </Tabs>

                    </div>
                </BlockUi>

            </div>
        );
    }
}
